import { render, staticRenderFns } from "./DiscountSwitchConnection.vue?vue&type=template&id=44ebed5e&scoped=true&"
import script from "./DiscountSwitchConnection.vue?vue&type=script&lang=js&"
export * from "./DiscountSwitchConnection.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSwitchConnection.vue?vue&type=style&index=0&id=44ebed5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ebed5e",
  null
  
)

export default component.exports